import { Global, css } from "@emotion/react"
/* import { useRecoilValue } from "recoil"
import { brandingSelector } from "../recoil/atoms/room" */
const GlobalStyle = () => {
  return (
    <Global
      styles={css`
        .todo ~ button {
          background: red !important;
          border-radius: 50% !important;
          padding: 5px !important;
        }

        .fade-enter {
          opacity: 0;
          z-index: 1;
        }

        .fade-enter.fade-enter-active {
          opacity: 1;
          transition: opacity 250ms ease-in;
        }
      `}
    />
  )
}

export default GlobalStyle
